const APP_CONFIG = {
    // Tytuł strony
    MAIN_PAGE_TITLE: 'Must Be The Music',

    // Parametr `portal` użyty w UserAgentData
    UAD_PORTAL: 'mbtm',

    // Stary format user agenta, przykład: `www_iplatv/12345`
    // Parametr `ua` nie będzie wysyłany, jeśli wartością tego pola jest pusty string
    BASE_USER_AGENT: '',

    // Alternatywny tekst dla logo
    LOGO_ALT: 'Must Be The Music',

    // Tekst w stopce strony
    FOOTER_TEXT: 'Telewizja Polsat Sp. z o.o., Ostrobramska 77, 04-175 Warszawa',
};

export default APP_CONFIG;
